<template>
  <AsrCreatePickCallLegacy
    v-if="isLegacyResident"
    :data="data"
    :closeModal="closeModal"
  />
  <AsrCreatePickCallNew v-else :data="data" :closeModal="closeModal" />
</template>

<script>
import { ASR_CREATE_PICK_CALL_LEGACY_RESIDENT_IDS } from "@/views/ResidentialSettings/services";
import AsrCreatePickCallLegacy from "./AsrCreatePickCallLegacy.vue";
import AsrCreatePickCallNew from "./AsrCreatePickCallNew.vue";

export default {
  name: "AsrCreatePickCall",
  components: { AsrCreatePickCallLegacy, AsrCreatePickCallNew },
  props: {
    data: { type: Object, required: true },
    closeModal: { type: Function, required: true },
  },
  computed: {
    isLegacyResident() {
      return ASR_CREATE_PICK_CALL_LEGACY_RESIDENT_IDS.includes(Number(this.data?.residentId));
    },
  },
};
</script>
